<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Role Permissions
      </div>
      <button class="ac-close-button" type="button" @click="toggleModal(false)">
        <img src="../../assets/img/general/x-black.png" alt="x" class="ac-close">
      </button>
    </div>
    <div class="ac-body-container">
      <div>
        Admin: Full access. Can edit any customer information, create new users, and change platform settings. (best
        for upper management, owners)
        <br />
        <br />
        Manager: Can edit customer information, cannot create new users (best for
        dispatchers, service managers)
        <br />
        <br />
        Viewer: Read-only access, no editing permitted (best for technicians)
      </div>
    </div>
    <div class="ac-footer-container">
      <div />
      <button class="ac-form-button" type="button" @click="goBackAndSave">
        <span class="warning-settings-go-back">
          Close
        </span>
      </button>
    </div>
  </div>
</template>
<script>

import partnerSettingsMixin from '../../mixins/partnerSettingsMixin';
import settingMixin from '../../mixins/settingMixin';

export default {
  name: 'RoleInfoPopup',
  mixins: [partnerSettingsMixin, settingMixin],
  data() {
    return {
      continue: false,
    };
  },
  methods: {
    leaveAnyway() {
      this.changePartnerSettingsValue('showRoleInfoPopup', false);
      this.toggleModal(false);
    },
    goBackAndSave() {
      this.changePartnerSettingsValue('showRoleInfoPopup', false);
      this.toggleModal(false);
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/variables.scss';

.warning-settings-leave-anyway {
  color: $WHITE;
  font-size: 14px;
  font-weight: bold;
}

.warning-settings-go-back {
  background-color: $NBLUE100;
  font-size: 14px;
  font-weight: bold;
}
</style>
